/**
 * @desc 交货单装箱率导出
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inMaster.packingProbabilityExport.Params, options?: any) {
  return updateResponse(
    http(URL + `/inMaster/packingProbabilityExport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
